import { Box, Chip } from '@mui/material';

import React from 'react';
import { isAddedField, isAddedOrRemovedField } from '@shared/filters/utils';
import { yyyymmddToDate } from '~/scripts/yyyymmdd';
import type { Filters } from '~/types/filters';
import { allFilters } from './filters';
import { FilterList } from '@mui/icons-material';
import { datasets } from '~/scenes/datasets';
import { isTagFilterField } from '@shared/filters';
interface ActiveFiltersChipsProps {
  filters: Filters.Filters;
  onChange?: (filters: Filters.Filters) => void;
  emptyState?: React.ReactNode;
  isLoading?: boolean;
}

const getFilterIcon = (key: keyof Filters.Filters) => {
  const keys = Object.keys(allFilters);
  let field = allFilters[key as keyof Filters.Filters];
  if (isAddedField(key)) {
    field = allFilters.added;
  }
  const IconComponent = field?.icon || FilterList;
  const colors = ['success', 'error', 'warning', 'info'] as const;
  return <IconComponent fontSize="small" color={colors[keys.indexOf(key)]} />;
};

const getFilterLabel = (key: keyof Filters.Filters, value: string) => {
  if (key === 'tld') {
    return `.${value}`;
  }
  if (value === 'missing') {
    return 'Other';
  }
  if (isAddedOrRemovedField(key)) {
    return yyyymmddToDate(value).toLocaleDateString();
  }
  if (key === 'tags' && isTagFilterField(value)) {
    void value;

    return datasets?.[value]?.name || value;
  }
  return value;
};

export default function ({
  filters,
  onChange,
  emptyState,
  isLoading,
}: ActiveFiltersChipsProps) {
  const noFiltersApplied = Object.keys(filters).length === 0;
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      flexWrap={'wrap'}
      justifyContent={'start'}>
      {!noFiltersApplied && (
        <FilterList fontSize="medium" sx={{ verticalAlign: 'middle', mr: 1 }} />
      )}
      {noFiltersApplied && emptyState && emptyState}
      {Object.entries(filters).map(([key, value]) => {
        let field = allFilters[key as keyof Filters.Filters];
        if (isAddedField(key)) {
          field = allFilters.added;
        }
        const isArrayValue = Array.isArray(value);
        const valueArray = isArrayValue ? value : [value];
        const prefix = field?.prefix || '';
        return (
          <React.Fragment key={key}>
            <Box display={'flex'} alignItems={'center'}>
              {valueArray.map((value) => {
                return (
                  <Chip
                    key={`${key}-${value}`}
                    label={`${prefix} ${getFilterLabel(key as keyof Filters.Filters, value)}`}
                    size="small"
                    disabled={isLoading}
                    icon={getFilterIcon(key as keyof Filters.Filters)}
                    variant="outlined"
                    sx={{
                      mr: 0.5,
                    }}
                    onDelete={
                      onChange
                        ? () => {
                            const update = isArrayValue
                              ? valueArray.filter((v) => v !== value)
                              : undefined;
                            const changeValue: Filters.Filters = {
                              ...filters,
                              [key]: update,
                            };
                            for (const key in changeValue) {
                              const updatedValue =
                                changeValue[key as keyof Filters.Filters];
                              if (
                                typeof updatedValue === 'undefined' ||
                                (Array.isArray(updatedValue) &&
                                  updatedValue.length === 0)
                              ) {
                                delete changeValue[
                                  key as keyof Filters.Filters
                                ];
                              }
                            }
                            onChange(changeValue);
                          }
                        : undefined
                    }
                  />
                );
              })}
            </Box>
          </React.Fragment>
        );
      })}
    </Box>
  );
}
